/* VoirClaire — interactions dynamiques globales. Progressive enhancement. */
(function () {
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  if (!reduced && !designMode) root.classList.add('vc-js');

  var NOT_HEADER = '.shopify-section:not(.section-header):not(.shopify-section-group-header-group)';
  var REVEAL_SELECTOR = [
    NOT_HEADER + ' h2',
    NOT_HEADER + ' .card-wrapper',
    NOT_HEADER + ' [class*="vc-"][class*="__card"]',
    NOT_HEADER + ' [class*="vc-"][class*="__item"]',
    NOT_HEADER + ' .multicolumn-card',
    NOT_HEADER + ' .image-with-text__media-item',
    NOT_HEADER + ' .image-with-text__text-item',
    NOT_HEADER + ' .rich-text__blocks > *',
  ].join(',');

  function setupReveal() {
    if (!('IntersectionObserver' in window) || !root.classList.contains('vc-js')) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    var seen = new WeakMap();
    document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
      if (el.hasAttribute('data-vc-reveal') || el.closest('.vc-hero')) return;
      var parent = el.parentElement;
      var idx = seen.get(parent) || 0;
      seen.set(parent, idx + 1);
      var dir = el.matches('.image-with-text__media-item') ? 'left' : el.matches('.image-with-text__text-item') ? 'right' : '';
      el.setAttribute('data-vc-reveal', dir);
      el.style.setProperty('--vc-i', Math.min(idx, 5));
      io.observe(el);
    });
    // Sécurité : rend visible ce qui est déjà à l'écran si l'observer ne déclenche pas.
    setTimeout(function () {
      document.querySelectorAll('[data-vc-reveal]:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      });
    }, 1500);
  }

  function setupHero() {
    document.querySelectorAll('.vc-hero__text > *').forEach(function (el, i) {
      el.style.setProperty('--vc-h', i);
    });
  }

  // Compteurs : <span data-vc-count="1200">0</span>
  function setupCounters() {
    var els = document.querySelectorAll('[data-vc-count]');
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var end = parseFloat(el.dataset.vcCount);
        var dec = (el.dataset.vcCount.split('.')[1] || '').length;
        var t0 = performance.now();
        (function tick(t) {
          var p = Math.min((t - t0) / 1400, 1);
          el.textContent = (end * (1 - Math.pow(1 - p, 3))).toFixed(dec);
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    });
    els.forEach(function (el) { io.observe(el); });
  }

  function setupChrome() {
    var bar = document.createElement('div');
    bar.className = 'vc-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var btn = document.createElement('button');
    btn.className = 'vc-totop';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Retour en haut');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);

    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0) + ')';
      root.classList.toggle('vc-scrolled', y > 10);
      btn.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function init() {
    setupHero();
    setupReveal();
    setupCounters();
    setupChrome();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    setupHero();
    setupReveal();
    setupCounters();
  });
})();
